import { useForm } from "@core/features/form";
import { useAccountMutation } from "@core/features/profile";
import { usePlatformStore } from "@platform/store";
import { User } from "@platform/types/platform.types";
import { Loader } from "@themes/pollinator/ui/Loader";
import { AccountForm } from "./AccountForm";

/**
 * Container component for AccountForm.
 * Handles mutations, store access, and form state management.
 */
export function AccountFormContainer() {
  const user = usePlatformStore((s) => s.user);
  const setUser = usePlatformStore((s) => s.setUser);

  const { schema, defaultValues, ...mutation } = useAccountMutation({
    currentEmail: user?.email || "",
    currentPhoneNumber: user?.phone_number || "",
    onUserUpdate: (userData) => {
      setUser(userData as unknown as User);
    },
  });

  const { form, handleSubmit } = useForm({
    schema,
    onSubmit: mutation.mutateAsync,
    defaultValues,
  });

  const handleCancel = () => {
    form.reset();
  };

  const { isSubmitting, isValid, isDirty } = form.formState;

  if (!user) {
    return <Loader />;
  }

  return (
    <AccountForm
      form={form}
      onSubmit={handleSubmit}
      onCancel={handleCancel}
      isDirty={isDirty}
      isValid={isValid}
      isSubmitting={isSubmitting}
    />
  );
}

export default AccountFormContainer;
